import id from './{id}';
import get from './get';
import post from './post';
import bulk from './bulk';

export type PostPayload = {
  aliasChannelName: string;
  aliasNodeId: number;
  endTime?: string;
  sourceChannelName?: string;
  sourceNodeId: number;
  startTime?: string;
};
export default { bulk, id, get, post };
